import styled from "styled-components";

export const Container = styled.div``;

export const Header = styled.div`
  width: 100%;
  height: 50px;
  color: #232323;
  border-bottom: 1px solid #dddddd;
  background: #ffffff;
`;

export const IncommingCallContainer = styled.div`
  background: #fff;
  width: 100px;
  height: 100px;
  position: relative;
  margin: 10px auto;
  border-radius: 100%;
  border: solid 2px #fff;
  animation: play 2s ease infinite;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden;

  @keyframes play {
    0% {
      transform: scale(1);
    }
    15% {
      box-shadow: 0 0 0 5px rgba(30, 139, 195, 0.4);
    }
    25% {
      box-shadow: 0 0 0 10px rgba(30, 139, 195, 0.4),
        0 0 0 20px rgba(30, 139, 195, 0.2);
    }
    25% {
      box-shadow: 0 0 0 15px rgba(30, 139, 195, 0.4),
        0 0 0 30px rgba(30, 139, 195, 0.2);
    }
  }
`;
